"use client";

import { useState, useRef } from "react";
import VideoModal from "@/components/VideoModal/VideoModal";

import Avatar from "../images/happy-customers/devi.png";
import Picture from "../images/happy-customers/vietnam-reviews-1.jpg";
import Review from "../images/happy-customers/google-review.svg";

import Avatar1 from "../images/happy-customers/thaygu.png";
import Picture1 from "../images/happy-customers/vietnam-reviews-2.jpg";

import Avatar2 from "../images/happy-customers/gauti.png";
import Picture2 from "../images/happy-customers/vietnam-reviews-3.jpg";

import Avatar3 from "../images/happy-customers/jay.png";
import Picture3 from "../images/happy-customers/vietnam-reviews-4.jpg";

import Avatar4 from "../images/happy-customers/vignesh.png";
import Picture4 from "../images/happy-customers/vietnam-reviews-5.jpg";

import Avatar5 from "../images/happy-customers/akash.png";
import Picture5 from "../images/happy-customers/vietnam-reviews-img.png";
import Picture6 from "../images/happy-customers/vietnam-reviews-img-1.png";

import "@/styles/common/customer-reviews.scss";
import "@/sections/common/happy-customers/happy-customers.scss";
import "@/styles/common/typo.scss";

import Button from "@/components/button/Button";
import Heading from "@/components/heading/heading";

import Image from "next/image";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const REVIEWS1 = [
    {
        id: 1,
        name: "Shalini Devi Ari",
        review: "I was a solo traveller and the destination  was Vietnam . Greatly appreciate the individual  customisation of their itinerary. The team is proactive in solving an issue that may arise too. Highly dependable and would definitely recommend them for anyones holiday plans .",
        image: Avatar,
    },
    {
        id: 2,
        showImage: true,
        image: Picture,
    },
    {
        id: 3,
        name: "S Thyagu",
        review: "Dear Dimaak Team, It was a great fun and pleasure trip with you guys. It was well planned and organised.Especially the organiser Anirudh was very helpful and easy to access for al kind of help and information. Great job dimaak. DIMAAK IS THE 👍💯!!!!!",
        image: Avatar1,
    },
    {
        id: 4,
        showImage: true,
        image: Picture1,
        thumbnail: Picture5,
        videoId: "BMnR5mqz8tM",
        videoTitle: "Thailand",
    },

    {
        id: 5,
        name: "Gauti Vijay",
        review: "Awesome arrangement from Dimaak tours Mr manikandan has guided us in every moment and clarfied all doubts and made trip hazzle free.. Thank you guys for making the trip memorable one.",
        image: Avatar2,
    },
    {
        id: 6,
        showImage: true,
        image: Picture2,
    },
]
const REVIEWS2 =[
    {
        id: 7,
        name: "Jonack J Gupta",
        review: "The Vietnam trip was close to perfect.The service was awesome and Dimaak rocks again 👍👏👌. A very special thanks to Dimaak,GK and Team 🙏🙏🙏",
        image: Avatar3,
    },
    {
        id: 8,
        showImage: true,
        image: Picture2,
        thumbnail: Picture6,
        videoId: "AVeZvoESpKI",
        videoTitle: "Maldives",
    },
    {
        id: 9,
        name: "Vignesh Babu",
        review: "One of the best travel planning agency I have reached out in recent times. Especially I have to thank Mr.Raj from dimaak tours who helped us in sorting out the right options which made our journey worth it. Very respectful, kind and friendly person. I would definitely choose this agency for all my future vacation trips.",
        image: Avatar4,
    },
    {
        id: 10,
        showImage: true,
        image: Picture3,
    },

    {
        id: 11,
        name: "Akshay Santhosh",
        review: "Excellent service and great assistance throughout the travel with prompt responses from our coordinator Raj. Thank you so much dimaak for an excellent experience.",
        image: Avatar5,
    },
    {
        id: 12,
        showImage: true,
        image: Picture4,
    },
];

const HappyCustomers = () => {
    const [modalStates, setModalStates] = useState(REVIEWS1.map(() => false));
    const [modal2States, setModal2States] = useState(REVIEWS2.map(() => false));
    const swiperRef1 = useRef<any>(null);
    const swiperRef2 = useRef<any>(null);

    const handleEnter = () => {
        swiperRef1.current.swiper.autoplay.stop();
        swiperRef2.current.swiper.autoplay.stop();
    };

    const handleLeave = () => {
        swiperRef1.current.swiper.autoplay.start();
        swiperRef2.current.swiper.autoplay.start();
    };

    const openModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = true;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = true;
            setModal2States(newModalStates);
        }
    };

    const closeModal = (index: number, reviewsListNo: number) => {
        if (reviewsListNo === 1) {
            const newModalStates = [...modalStates];
            newModalStates[index] = false;
            setModalStates(newModalStates);
        } else {
            const newModalStates = [...modal2States];
            newModalStates[index] = false;
            setModal2States(newModalStates);
        }
    };

    return (
        <section className="happy-customers-section">
            <div className="container px-4 mx-auto flex flex-col gap-6 sm:gap-14">
                <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
                    <div className="happy-customers-block col-span-1 flex flex-col justify-center items-start gap-3 sm:gap-6 lg:col-span-1">
                        <small className="font-yesteryear font-extralight">
                            Our Customers Love
                        </small>
                        <Heading as="h2">Travel Experiences</Heading>
                        <p className="lead">
                            Discover what our valued customers have to say about their unforgettable experiences. Read genuine reviews and testimonials showcasing the joy and satisfaction of their journeys with us
                        </p>
                        <div className="button-review flex flex-wrap items-center gap-6">
                            <Button
                                onClick={() =>
                                    window.open(
                                        "https://bit.ly/dimaakreviews",
                                        "_blank"
                                    )
                                }
                                className="flex items-center"
                                variant="orange"
                            >
                                <span>View more Reviews</span>
                            </Button>
                            <Image loading="lazy"
                                src={Review}
                                alt="Review"
                                className="review"
                                
                            />
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-vertical col-span-1 flex-col gap-4 lg:col-span-2 hidden lg:flex">
                        <div
                            className="grid-cols-1 gap-6 lg:grid-cols-2 grid"
                            onMouseEnter={handleEnter}
                            onMouseLeave={handleLeave}
                        >
                            <div className="happy-customers-slider-one happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef1}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS1?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    1
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modalStates[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                1
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                            <div className="happy-customers-slider-two happy-customers-slider col-span-1 flex flex-col gap-4 lg:col-span-1">
                                <Swiper
                                    ref={swiperRef2}
                                    slidesPerView={1.5}
                                    spaceBetween={30}
                                    centeredSlides={true}
                                    direction="vertical"
                                    speed={3000}
                                    modules={[Autoplay]}
                                    autoplay={{
                                        delay: 1,
                                        disableOnInteraction: false,
                                        waitForTransition: true,
                                        pauseOnMouseEnter: true,
                                        reverseDirection: true,
                                    }}
                                    loop={true}
                                    className="swiper-container"
                                    onSlideChange={(e) => {}}
                                    onSwiper={(swiper) => {}}
                                    autoHeight={true}
                                    height={400}
                                >
                                    {REVIEWS2?.map((review, index) => (
                                        <SwiperSlide
                                            key={review.id}
                                            className={`swiper-slide ${
                                                review.showImage
                                                    ? "with-image-h"
                                                    : "without-image-h"
                                            }`}
                                            style={{
                                                height: "100% !important",
                                                color: "red",
                                            }}
                                        >
                                            {review.showImage ? (
                                                <div className="with-image h-full">
                                                    {review.videoId ? (
                                                        <div
                                                            className="picture object-fill h-full"
                                                            onClick={() =>
                                                                openModal(
                                                                    index,
                                                                    2
                                                                )
                                                            }
                                                            style={{
                                                                cursor: "pointer",
                                                            }}
                                                        >
                                                            <Image
                                                                loading="lazy"
                                                                src={
                                                                    review.thumbnail
                                                                }
                                                                alt="Picture"
                                                                className="picture object-fill h-full"
                                                            />
                                                            <div
                                                                className="play-button"
                                                                style={{
                                                                    position:
                                                                        "absolute",
                                                                    top: "50%",
                                                                    left: "50%",
                                                                    transform:
                                                                        "translate(-50%, -50%)",
                                                                    cursor: "pointer",
                                                                }}
                                                            >
                                                                <svg
                                                                    width="61"
                                                                    height="61"
                                                                    viewBox="0 0 61 61"
                                                                    fill="none"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <circle
                                                                        cx="30.5"
                                                                        cy="30.5"
                                                                        r="30.5"
                                                                        fill="#FFF3ED"
                                                                    />
                                                                    <path
                                                                        d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                        fill="#FF4514"
                                                                    />
                                                                </svg>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Picture"
                                                            className="picture object-fill h-full"
                                                        />
                                                    )}

                                                    <VideoModal
                                                        videoTitle={
                                                            review.videoTitle
                                                        }
                                                        videoId={review.videoId}
                                                        isOpen={
                                                            modal2States[index]
                                                        }
                                                        onClose={() => {
                                                            closeModal(
                                                                index,
                                                                2
                                                            );
                                                            swiperRef1.current.swiper.autoplay.start();
                                                            swiperRef2.current.swiper.autoplay.start();
                                                        }}
                                                    />
                                                </div>
                                            ) : (
                                                <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                                    <p className="lead">
                                                        {review.review}
                                                    </p>
                                                    <div className="avatar flex items-center mt-auto gap-3">
                                                        <Image
                                                            loading="lazy"
                                                            src={review.image}
                                                            alt="Avatar"
                                                            className="avatar"
                                                        />
                                                        <span className="font-semibold">
                                                            {review.name}
                                                        </span>
                                                    </div>
                                                </div>
                                            )}
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className="happy-customers-slider happy-customers-slider-horizontal col-span-1 flex flex-col gap-4 lg:col-span-1 mt-4 h-32">
                        <Swiper
                            slidesPerView={1.5}
                            spaceBetween={30}
                            centeredSlides={true}
                            direction="horizontal"
                            speed={3000}
                            modules={[Autoplay]}
                            autoplay={{
                                delay: 1,
                                disableOnInteraction: false,
                                waitForTransition: true,
                                pauseOnMouseEnter: true,
                            }}
                            loop={true}
                            className="swiper-container"
                            autoHeight={false}
                            height={100}
                        >
                            {REVIEWS1?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 1)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                            {REVIEWS2?.map((review, index) => (
                                <SwiperSlide
                                    key={review.id}
                                    className={`swiper-slide ${
                                        review.showImage
                                            ? "with-image-h"
                                            : "without-image-h"
                                    }`}
                                    style={{
                                        height: "100% !important",
                                        color: "red",
                                    }}
                                >
                                    {review.showImage ? (
                                        <div className="with-image h-full">
                                            {review.videoId ? (
                                                <div
                                                    className="picture object-fill h-full"
                                                    onClick={() =>
                                                        openModal(index, 2)
                                                    }
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                >
                                                    <Image
                                                        loading="lazy"
                                                        src={review.thumbnail}
                                                        alt="Picture"
                                                        className="picture object-fill h-full"
                                                    />
                                                    <div
                                                        className="play-button"
                                                        style={{
                                                            position:
                                                                "absolute",
                                                            top: "50%",
                                                            left: "50%",
                                                            transform:
                                                                "translate(-50%, -50%)",
                                                            cursor: "pointer",
                                                        }}
                                                    >
                                                        <svg
                                                            width="61"
                                                            height="61"
                                                            viewBox="0 0 61 61"
                                                            fill="none"
                                                            xmlns="http://www.w3.org/2000/svg"
                                                        >
                                                            <circle
                                                                cx="30.5"
                                                                cy="30.5"
                                                                r="30.5"
                                                                fill="#FFF3ED"
                                                            />
                                                            <path
                                                                d="M42 30L24 40.3923L24 19.6077L42 30Z"
                                                                fill="#FF4514"
                                                            />
                                                        </svg>
                                                    </div>
                                                </div>
                                            ) : (
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Picture"
                                                    className="picture object-fill h-full"
                                                />
                                            )}
                                        </div>
                                    ) : (
                                        <div className="without-image p-4 xl:p-6 flex flex-col gap-3 h-full">
                                            <p className="lead">
                                                {review.review}
                                            </p>
                                            <div className="avatar flex items-center mt-auto gap-3">
                                                <Image
                                                    loading="lazy"
                                                    src={review.image}
                                                    alt="Avatar"
                                                    className="avatar"
                                                />
                                                <span className="font-semibold">
                                                    {review.name}
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HappyCustomers;
